export const isObjectValuesFalsy = object => {
  for (const value of Object.values(object)) {
    if (!value || value.length < 1) {
      return true;
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/validation.js